module.exports = __webpack_public_path__ + "src/assets/images/delete-icon.c99845a2c075eda24d91014fa63459a5.jpg";